const ENGLISH_LANGUAGE_CODE = 'en'
const REG_EXP_LANGUAGE_CODE = /^([A-Z]{2})\s*-\s*(.+)$/

export function getLanguageName(code?: string) {
  const languageCode = code || ENGLISH_LANGUAGE_CODE
  const languageName = new Intl.DisplayNames([ENGLISH_LANGUAGE_CODE], {type: 'language'})
  return languageName.of(languageCode) || languageCode
}

export function getFullLanguageTitle(title: string) {
  const match = title.match(REG_EXP_LANGUAGE_CODE)
  if (!match) {
    return undefined
  }

  const [, code, baseTitle] = match
  const fullLanguageName = getLanguageName(code)

  return `${fullLanguageName} - ${baseTitle.trim()}`
}
